import { Controller } from "@hotwired/stimulus"

// Manejo dinámico de filas de tributos en la vista de validación:
// - "Agregar" clona el template y reescribe NEW_IDX por timestamp único
//   para que cada fila tenga su propio key en invoice_tributos_attributes
// - "Eliminar" marca _destroy=1 si es persistida, o quita la fila si es nueva
// - Recalcula monto = base × alicuota / 100 cuando editás base o alícuota
export default class extends Controller {
  static targets = ["tbody", "template", "row", "destroy", "amount"]

  add() {
    const html = this.templateTarget.innerHTML.replaceAll("NEW_IDX", Date.now() + Math.floor(Math.random() * 1000))
    this.tbodyTarget.insertAdjacentHTML("beforeend", html)
    this.syncOtros()
  }

  remove(event) {
    const row = event.target.closest("tr")
    if (!row) return
    const destroyInput = row.querySelector('[data-tributo-rows-target="destroy"]')
    const idInput = row.querySelector('input[name$="[id]"]')

    if (idInput && idInput.value) {
      // Fila persistida → marcar para destroy + ocultar
      destroyInput.value = "1"
      row.style.display = "none"
    } else {
      // Fila nueva → quitar del DOM
      row.remove()
    }
    this.syncOtros()
  }

  recalc(event) {
    const row = event.target.closest("tr")
    if (!row) return
    const base = parseFloat(row.querySelector('input[name$="[base_imponible_pesos]"]')?.value) || 0
    const alic = parseFloat(row.querySelector('input[name$="[alicuota]"]')?.value) || 0
    const amount = (base * alic / 100).toFixed(2)
    const amountInput = row.querySelector('input[name$="[amount_pesos]"]')
    if (amountInput) amountInput.value = amount
    this.syncOtros()
  }

  // Suma todas las filas (percepción SUMA, retención RESTA) y escribe el total en
  // el campo "Otros tributos" de la caja de Totales, disparando el recálculo del
  // "Total factura". Así, editar las filas se refleja en vivo en lo que se guarda.
  // Solo corre al tocar las filas → el operador puede igual pisar "Otros tributos"
  // a mano (ej. dejar una retención como dato pero con otros = 0).
  syncOtros() {
    const otrosInput = document.querySelector('[data-invoice-validation-target="otrosTributos"]')
    if (!otrosInput) return
    let sumCents = 0
    this.rowTargets.forEach(row => {
      if (row.style.display === "none") return // marcada para destroy
      const amount = parseFloat(row.querySelector('input[name$="[amount_pesos]"]')?.value) || 0
      const isRet = row.querySelector('input[type="checkbox"][name$="[is_retencion]"]')?.checked
      sumCents += Math.round(amount * 100) * (isRet ? -1 : 1)
    })
    otrosInput.value = (sumCents / 100).toFixed(2)
    otrosInput.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
